define('home/templates/uploadButton',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<button type=\"button\" class=\"button text-smaller link-gray\" data-action=\"attach\" title=\"Upload Images\">\n<span class=\"icon-photo icon__position -inline\"></span>\n</button>\n<input type=\"file\" class=\"hidden\" data-role=\"media-upload\" tabindex=\"-1\" accept=\"image/*\">\n";
},"useData":true})

});
